import { useState } from 'react';
import { ImageOff } from 'lucide-react';
import type { TrackerImage } from '@pms/shared';
import { AuthImage } from '@/components/ui/auth-image';
import { cn } from '@/lib/utils';
import { trackingService } from '@/services/tracking.service';

interface Props {
  image: TrackerImage;
  className?: string;
}

/**
 * A screenshot: the direct R2 url first, then the PMS proxy (for a private bucket or a
 * blocked CDN), then a "file deleted" tile once the object is gone from the bucket.
 */
export function TrackerShotImage({ image, className }: Props) {
  const [directFailed, setDirectFailed] = useState(!image.url);
  const alt = `Screenshot ${image.capturedAt} · ${image.monitor}`;

  const gone = (
    <div className={cn('flex flex-col items-center justify-center gap-1 bg-muted/60 text-muted-foreground', className)}>
      <ImageOff className="h-5 w-5" />
      <span className="text-[11px]">file deleted</span>
    </div>
  );

  if (!directFailed && image.url) {
    return (
      <img
        src={image.url}
        alt={alt}
        loading="lazy"
        className={cn('object-cover', className)}
        onError={() => setDirectFailed(true)}
      />
    );
  }

  return (
    <AuthImage
      src={trackingService.imageFilePath(image.id)}
      alt={alt}
      className={cn('object-cover', className)}
      fallback={gone}
    />
  );
}
